import { ActionTypes as actions } from '../actions';

const initialState = {
  instantSessions: null,
  sessionsStatusDict: null,
  completedSessionIds: null,
  cancelledSessionIds: [],
  instantUserPractice: null,
  instantUserPracticeLocation: null,
  instantPageState: null,
  validationInfo: {},
}

export default function InstantReducer(state=initialState, action) {

  switch(action.type) {
    case actions.INSTANT_PRACTICE_UPDATE:
      state = { ...state, instantUserPractice: action.payload };
      break;
    case actions.INSTANT_LOCATION_UPDATE:
      state = { ...state, instantUserPracticeLocation: action.payload };
      break;
    case actions.INSTANT_DICT_UPDATE:
      state = { ...state, instantSessions: action.payload };
      break;
    case actions.INSTANT_DICT_UPDATE_ITEM:
      let current_dict   = Object.assign({}, state.instantSessions);
      let item_to_update = action.payload;
      if (item_to_update && item_to_update._id) {
        current_dict[item_to_update._id] = item_to_update;
      }
      state = { ...state, instantSessions: current_dict };
      break;
    case actions.INSTANT_STATUS_DICT_UPDATE:
      state = { ...state, sessionsStatusDict: action.payload };
      break;
    case actions.INSTANT_COMPLETED_CANCELLED_IDS_UPDATE:
      let ids_dict = action.payload;
      let completed_ids = ids_dict['COMPLETED'];
      let cancelled_ids = ids_dict['CANCELLED'];
      state = { ...state, completedSessionIds: completed_ids, cancelledSessionIds: cancelled_ids };
      break;
    case actions.INSTANT_UPDATE_COMPLETED_IDS:
      let existing_sort_dict     = Object.assign({}, state.sessionsStatusDict);
      let new_completed_arr      = action.payload;
      existing_sort_dict['COMPLETED'] = new_completed_arr;
      state = { ...state, sessionsStatusDict: existing_sort_dict };
      break;
    case actions.INSTANT_UPDATE_NON_COMPLETED_IDS:
      let existing_dict = Object.assign({}, state.sessionsStatusDict);
      let new_dict      = action.payload;
      existing_dict['INVITED']     = new_dict['INVITED'];
      existing_dict['IN_PROGRESS'] = new_dict['IN_PROGRESS'];
      state = { ...state, sessionsStatusDict: existing_dict };
      break;
    case actions.INSTANT_UPDATE_PAGE_STATE:
      state = { ...state, instantPageState: action.payload };
      break;
    case actions.INSTANT_UPDATE_DISPLAY_VALIDATION:
      state = { ...state, validationInfo: action.payload };
      break;
    case actions.USER_SIGN_OUT:
      state = initialState;
      break;
    case actions.INSTANT_CLEAR_DATA:
        state = {
          ...state,
          instantSessions: null,
          instantPageState: null,
          sessionsStatusDict: null,
          completedSessionIds: null,
          cancelledSessionIds: null,
        };
        break;
    default:
        break;
  }

  return state;
}
